import { Create } from 'react-admin';
import { CompanyForm } from './index';

export const CompanyCreate = () => (
  <Create>
    <CompanyForm />
  </Create>
);
